import {
    DISPATCH_FAILED,
    DISPATCH_REQUEST,
    DISPATCH_SUCCESS,
} from "app/redux/actions/Dispatch/constant";

const INIT_STATE = {
    loading: false,
    totalPage: 0,
    data: [],
    error: {
        isError: false,
        message: null,
    },
};

export const dispatchListReducer = function (state = INIT_STATE, action) {
    switch (action?.type) {
        case DISPATCH_REQUEST:
            return {
                loading: true,
                totalPage: 0,
                data: [],
                error: {
                    isError: false,
                    message: null,
                },
            };
        case DISPATCH_SUCCESS:
            return {
                loading: false,
                data: action?.payload?.data,
                totalPage: action?.payload?.totalPage,
                error: {
                    isError: false,
                    message: null,
                },
            };
        case DISPATCH_FAILED:
            const { isError = true, message = "Something Went Wrong" } =
                action?.payload?.error || {};
            return {
                loading: false,
                totalPage: 0,
                data: [],
                error: {
                    isError: isError,
                    message: message,
                },
            };
        default:
            return state;
    }
};
